import React, { useMemo, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Icon from "../atoms/Icon";
import Button from "../atoms/Button";
import mapPin from "../../assets/mapPin.png";
import Text from "../atoms/Text";
import arrow from "../../assets/downArrow.png";
import logo from "../../assets/Logo.png";
import wishlist from "../../assets/heart.png";
import cart from "../../assets/cart.png";
import bars from "../../assets/burgerbars.png";
import Navbar from "../molecules/Navbar";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleDown } from "@fortawesome/free-solid-svg-icons";
import phone from "../../assets/phone.png";
import { useUser } from "../../context/UserContext";
import products from "../../data/products.json";

export default function Header() {
  const navigate = useNavigate();
  const { cartTotal, currentUser, isAuthenticated, removeFromCart } = useUser();
  const [isCartPopupOpen, setIsCartPopupOpen] = useState(false);
  const cartItems = useMemo(() => {
    if (!currentUser?.cart?.length) {
      return [];
    }

    return currentUser.cart
      .map((cartItem) => {
        const productItem = products.find((item) => item.id === cartItem.productId);

        if (!productItem) {
          return null;
        }

        return {
          ...productItem,
          quantity: cartItem.quantity,
        };
      })
      .filter(Boolean);
  }, [currentUser]);
  const cartItemCount = cartItems.reduce((sum, item) => sum + item.quantity, 0);

  function handleCartPopupNavigation(path) {
    setIsCartPopupOpen(false);
    navigate(path);
  }

  return (
    <>
      {isCartPopupOpen ? (
        <div
          style={{
            position: "fixed",
            inset: 0,
            zIndex: 1000,
            display: "flex",
            justifyContent: "flex-end",
            backgroundColor: "rgba(0, 0, 0, 0.45)",
          }}
          onClick={() => setIsCartPopupOpen(false)}
        >
          <div
            style={{
              width: "420px",
              minHeight: "100vh",
              backgroundColor: "var(--white)",
              padding: "32px 24px 24px",
              display: "flex",
              flexDirection: "column",
              boxSizing: "border-box",
            }}
            onClick={(event) => event.stopPropagation()}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "20px",
              }}
            >
              <Text size="px24" weight="w500" color="gray9">
                Shopping Cart ({cartItemCount})
              </Text>
              <button
                type="button"
                onClick={() => setIsCartPopupOpen(false)}
                style={{
                  border: "none",
                  backgroundColor: "transparent",
                  fontSize: "24px",
                  lineHeight: 1,
                  cursor: "pointer",
                  color: "var(--gray7)",
                  padding: 0,
                }}
              >
                x
              </button>
            </div>

            <div style={{ display: "flex", flexDirection: "column", gap: "2px", flex: 1 }}>
              {cartItems.length === 0 ? (
                <Text size="px16" weight="w400" color="gray5">
                  Your cart is empty.
                </Text>
              ) : (
                cartItems.map((item) => (
                  <div
                    key={item.id}
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      gap: "12px",
                      padding: "18px 0",
                      borderBottom: "1px solid var(--gray1)",
                    }}
                  >
                    <div style={{ display: "flex", alignItems: "center", gap: "12px", minWidth: 0 }}>
                      <img
                        src={item.image}
                        alt={item.name}
                        style={{ width: "70px", height: "70px", objectFit: "contain", flexShrink: 0 }}
                      />
                      <div style={{ display: "flex", flexDirection: "column", gap: "6px", minWidth: 0 }}>
                        <Text size="px14" weight="w400" color="gray9" extraStyles={{ textAlign: "start" }}>
                          {item.name}
                        </Text>
                        <Text size="px14" weight="w400" color="gray5" extraStyles={{ textAlign: "start" }}>
                          {item.quantity} kg x ${item.price.toFixed(2)}
                        </Text>
                      </div>
                    </div>

                    <button
                      type="button"
                      onClick={() => removeFromCart(item.id)}
                      style={{
                        width: "24px",
                        height: "24px",
                        borderRadius: "50%",
                        border: "1px solid var(--gray2)",
                        backgroundColor: "var(--white)",
                        color: "var(--gray4)",
                        fontSize: "14px",
                        lineHeight: 1,
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        padding: 0,
                        flexShrink: 0,
                      }}
                    >
                      x
                    </button>
                  </div>
                ))
              )}
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                paddingTop: "20px",
                marginTop: "auto",
              }}
            >
              <Text size="px16" weight="w400" color="gray9">
                {cartItems.length} Product
              </Text>
              <Text size="px20" weight="w600" color="gray9">
                ${cartTotal.toFixed(2)}
              </Text>
            </div>

            <Button
              size="large"
              variant="fill"
              type="button"
              onClick={() => handleCartPopupNavigation("/checkout")}
              style={{ width: "100%", marginTop: "20px" }}
            >
              Checkout
            </Button>
            <Button
              size="large"
              variant="ghost"
              type="button"
              onClick={() => handleCartPopupNavigation("/cart")}
              style={{ width: "100%", marginTop: "12px" }}
            >
              Go To Cart
            </Button>
          </div>
        </div>
      ) : null}

      <div
        className="locationBar"
        style={{
          backgroundColor: "var(--gray8)",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <div
          className="address"
          style={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
            padding: "12px 0px 12px 300px",
          }}
        >
          <Icon name="location" src={mapPin} size="width: 15px; height: 18px" />
          <Text size="px12" color="gray3" weight="w400">
            Store Location: Lincoln- 344, Illinois, Chicago, USA
          </Text>
        </div>
        <div
          className="quickLinks"
          style={{ display: "flex", alignItems: "center" }}
        >
          <div
            className="currencyLang"
            style={{
              display: "flex",
              alignItems: "center",
              gap: "20px",
              padding: "12px 300px 12px 0px",
              borderRight: "1px solid var(--gray8)",
            }}
          >
            <Text size="px12" color="gray3" weight="w400">
              Eng{" "}
              <Icon name="arrow" size="width: 7px; height: 3.5px" src={arrow} />
            </Text>
            <Text size="px12" color="gray3" weight="w400">
              USD{" "}
              <Icon name="arrow" size="width: 7px; height: 3.5px" src={arrow} />
            </Text>

            <span
              style={{
                height: "15px",
                backgroundColor: "var(--gray3)",
                width: "1px",
              }}
            ></span>
            <Link
              to={isAuthenticated ? "/profile" : "/auth"}
              style={{ textDecoration: "none" }}
            >
              <Text
                size="px12"
                color="gray3"
                weight="w400"
                extraStyles={{
                  cursor: "pointer",
                  color: "var(--gray3)",
                }}
              >
                {isAuthenticated ? currentUser?.name || "My Profile" : "Log In / Sign Up"}
              </Text>
            </Link>
          </div>
        </div>
      </div>
      <div
        className="mainHeader"
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "20px 300px",
        }}
      >
        <Link to="/" style={{ display: "inline-flex", cursor: "pointer" }}>
          <Icon name="logo" src={logo} size="width: 183px; height: 38px;" />
        </Link>
        <div className="cartActions" style={{ display: "flex", gap: "20px" }}>
          <Link
            to="/wishlist"
            style={{ display: "inline-flex", alignItems: "center", cursor: "pointer" }}
          >
            <Icon
              name="wishlist"
              src={wishlist}
              size="width: 27.67px; height: 23.8px;"
              style={{ cursor: "pointer" }}
            />
          </Link>
          <span
            style={{
              width: "1px",
              height: "24px",
              backgroundColor: "var(--gray2)",
              flexShrink: 0,
              alignSelf: "center",
            }}
          ></span>
          <button
            type="button"
            onClick={() => setIsCartPopupOpen(true)}
            style={{
              border: "none",
              backgroundColor: "transparent",
              display: "flex",
              alignItems: "center",
              gap: "12px",
              padding: 0,
              cursor: "pointer",
            }}
          >
            <div
              className="cartContainer"
              style={{ display: "flex", alignItems: "center", gap: "12px" }}
            >
              <Icon
                name="cart"
                src={cart}
                size="width: 25.5px; height: 25.5px;"
                style={{ cursor: "pointer" }}
              />
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                }}
              >
                <Text
                  size="px12"
                  color="gray7"
                  weight="w400"
                  extraStyles={{ color: "var(--gray7)" }}
                >
                  Shopping Cart
                </Text>
                <Text size="px14" color="gray9" weight="w500" id="cartTotal">
                  ${cartTotal.toFixed(2)}
                </Text>
              </div>
            </div>
          </button>
        </div>
      </div>
      <div
        className="navBar"
        style={{
          backgroundColor: "var(--gray05)",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "0px 300px",
        }}
      >
        <div style={{ display: "flex", gap: "32px" }}>
          <Text
            size="px14"
            color="white"
            weight="w500"
            extraStyles={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
              backgroundColor: "var(--primary)",
              padding: "21px 27px",
            }}
          >
            <Icon
              name="bars"
              src={bars}
              size="width: 18px; height: 14px;"
              style={{ alignItems: "center" }}
            />
            All Categories
            <FontAwesomeIcon icon={faAngleDown} />
          </Text>
          <Navbar />
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <Icon src={phone} size="width: 20px; height: 20px;" />
          <Text size="px14" color="gray9" weight="w500">
            (219) 555-0114
          </Text>
        </div>
      </div>
    </>
  );
}
